export const tableColumn = [
	{
		label: '姓名',
		prop: 'username',
		width: '150px',

	},
	{
		label: '部门',
		prop: 'deptName',
	},
	{
		label: '新数据量',
		prop: 'newCustomerNum',
	},
	{
		label: '跟进客户量',
		prop: 'flowCustomerNum',
	},
	{
		label: '通次',
		prop: 'callNum',
	},
	{
		label: '有效通时>15秒(min)',
		prop: 'effectiveDuration',
		// width: '120px',
	},
	{
		label: '通时(min)',
		prop: 'callDuration',
		// width: '120px',
	},
	{
		label: '来电时长(min)',
		prop: 'fromDuration',
		width: '120px',
	},
	{
		label: '去电时长(min)',
		prop: 'toDuration',
		// width: '120px',
	}
]
